import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'; // WYMAGANE: npm install axios

// === IMPORTY ZASOBÓW (Zostawiam Twoje ścieżki) ===
import logo from '../../img/orzel_logo_192.png';
import NotebookBackground from '../../img/NotebookBackground';

// === IMPORTY IKON ===
import { 
  FiMenu, 
  FiX, 
  FiTrendingUp, 
  FiShield, 
  FiSend, 
  FiLoader, 
  FiCheckCircle,
  FiRepeat 
} from 'react-icons/fi';

// Pobieranie URL API ze zmiennych środowiskowych
// Upewnij się, że w .env masz np. REACT_APP_API_SOURCE=http://localhost:8000/api/
const apiUrl = process.env.REACT_APP_API_SOURCE;

// ===================================================================
// === KOMPONENTY POMOCNICZE ===
// ===================================================================

const StudentBenefitItem = ({ icon, title, children }) => (
  <div className="flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-xl text-[#233855]">
    <div className="flex-shrink-0 text-[#E09F2E] mb-4">{icon}</div> 
    <div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="opacity-80">{children}</p> 
    </div>
  </div>
);

// --- Formularz Kontaktowy B2B (Zaktualizowany o logikę i RODO) ---
const ContactFormB2B = () => {
  const [formData, setFormData] = useState({
    email: '',
    school: '',
    message: '',
    privacyAccepted: false,
    marketingAccepted: false
  });

  const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    // 1. Walidacja checkboxa wymaganego (Polityka Prywatności)
    if (!formData.privacyAccepted) {
      setErrorMessage("Akceptacja polityki prywatności jest wymagana.");
      return;
    }

    setStatus('sending');

    try {
      // 2. Wysyłka do backendu (widok oparty na funkcji, który zrobiliśmy)
      // Endpoint: /contact-school/ (sprawdź w urls.py czy masz taki sam suffix)
      await axios.post(`${apiUrl}contact-school/`, {
        email: formData.email,
        school: formData.school,
        message: formData.message,
        // Mapowanie na nazwy pól w Pythonie:
        privacy_policy_accepted: formData.privacyAccepted,
        marketing_consent: formData.marketingAccepted
      });

      console.log("Wysłano pomyślnie");
      setStatus('success');
      
      // Reset formularza
      setFormData({ 
        email: '', 
        school: '', 
        message: '', 
        privacyAccepted: false, 
        marketingAccepted: false 
      });

    } catch (error) {
      console.error(error);
      setStatus('error');
      // Prosta obsługa błędów z backendu
      if (error.response && error.response.data) {
          // Jeśli backend zwróci konkretny błąd (np. zły email)
          const apiError = Object.values(error.response.data)[0];
          setErrorMessage(typeof apiError === 'string' ? apiError : "Wystąpił błąd walidacji danych.");
      } else {
          setErrorMessage("Nie udało się połączyć z serwerem. Spróbuj później.");
      }
    }
  };

  if (status === 'success') {
    return (
      <div className="flex flex-col items-center justify-center text-center p-8 bg-white/10 rounded-lg h-full border border-green-500/30">
        <FiCheckCircle className="text-green-500 w-16 h-16 mb-4" />
        <h3 className="text-xl font-semibold text-white mb-2">Dziękujemy za wiadomość!</h3>
        <p className="text-white/80">Twoje zgłoszenie zostało zapisane. Odezwiemy się najszybciej, jak to możliwe.</p>
        <button 
          onClick={() => setStatus('idle')}
          className="mt-6 text-[#E09F2E] hover:text-[#f0b045] underline text-sm transition-colors"
        >
          Wyślij kolejną wiadomość
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Email */}
      <div>
        <label htmlFor="email" className="ph-no-capture block text-sm font-medium text-white/80">Twój E-mail <span className="text-red-400">*</span></label>
        <input
          type="email"
          name="email"
          id="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="mt-1 block w-full px-3 py-2 bg-white/10 border border-gray-700 rounded-md text-white shadow-sm focus:outline-none focus:ring-[#E09F2E] focus:border-[#E09F2E]"
        />
      </div>

      {/* Szkoła */}
      <div>
        <label htmlFor="school" className="ph-no-capture block text-sm font-medium text-white/80">Szkoła / Firma (opcjonalnie)</label>
        <input
          type="text"
          name="school"
          id="school"
          value={formData.school}
          onChange={handleChange}
          className="mt-1 block w-full px-3 py-2 bg-white/10 border border-gray-700 rounded-md text-white shadow-sm focus:outline-none focus:ring-[#E09F2E] focus:border-[#E09F2E]"
        />
      </div>

      {/* Wiadomość */}
      <div>
        <label htmlFor="message" className="block text-sm font-medium text-white/80">W czym możemy pomóc? / Twoje uwagi <span className="text-red-400">*</span></label>
        <textarea
          name="message"
          id="message"
          rows={4}
          value={formData.message}
          onChange={handleChange}
          required
          className="mt-1 block w-full px-3 py-2 bg-white/10 border border-gray-700 rounded-md text-white shadow-sm focus:outline-none focus:ring-[#E09F2E] focus:border-[#E09F2E]"
        />
      </div>

      {/* === SEKCJA RODO === */}
      <div className="space-y-4 pt-2 border-t border-gray-700/50 mt-4">
        
        {/* 1. Polityka Prywatności (Wymagana) */}
        <div className="flex items-start gap-3">
          <div className="flex items-center h-5">
            <input
              id="privacyAccepted"
              name="privacyAccepted"
              type="checkbox"
              checked={formData.privacyAccepted}
              onChange={handleChange}
              // Nie używamy 'required' w HTML bo chcemy obsłużyć błąd customowym komunikatem, 
              // ale można dodać dla UX. Tutaj polegam na walidacji w JS.
              className="w-4 h-4 rounded border-gray-600 bg-white/10 text-[#E09F2E] focus:ring-[#E09F2E] focus:ring-offset-gray-900 cursor-pointer"
            />
          </div>
          <label htmlFor="privacyAccepted" className="text-xs text-white/70 leading-relaxed cursor-pointer">
            Zapoznałem się z <Link to="/privacy-policy" className="text-[#E09F2E] hover:underline" target="_blank">polityką prywatności</Link>. <span className="text-red-400">*</span>
          </label>
        </div>

        {/* 2. Zgoda Marketingowa (Opcjonalna) */}
        <div className="flex items-start gap-3">
          <div className="flex items-center h-5">
            <input
              id="marketingAccepted"
              name="marketingAccepted"
              type="checkbox"
              checked={formData.marketingAccepted}
              onChange={handleChange}
              className="w-4 h-4 rounded border-gray-600 bg-white/10 text-[#E09F2E] focus:ring-[#E09F2E] focus:ring-offset-gray-900 cursor-pointer"
            />
          </div>
          <label htmlFor="marketingAccepted" className="text-xs text-white/60 leading-relaxed text-justify cursor-pointer">
            Wyrażam zgodę na używanie mojego adresu e-mail przez MATEMATLY sp. z o.o. (Al. Powstania Warszawskiego 15, 31-539 Kraków) do celów przesyłania informacji handlowej w rozumieniu przepisów ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną, w tym marketingu bezpośredniego, za pośrednictwem poczty elektronicznej.
          </label>
        </div>
    

      </div>

      {/* Komunikat o błędzie */}
      {errorMessage && (
        <div className="text-red-300 bg-red-900/40 border border-red-500/30 p-3 rounded-md text-sm text-center">
          {errorMessage}
        </div>
      )}

      {/* Przycisk */}
      <div className="pt-2">
        <button
          type="submit"
          disabled={status === 'sending'}
          className="w-full flex justify-center items-center gap-3 px-10 py-4 text-lg font-semibold text-blue-950 bg-[#E09F2E] rounded-lg shadow-lg transition-transform hover:scale-105 font-apotek uppercase disabled:opacity-70 disabled:cursor-wait disabled:hover:scale-100"
        >
          {status === 'sending' ? (
            <>
              <FiLoader className="animate-spin" />
              Wysyłanie...
            </>
          ) : (
            <>
              <FiSend />
              Wyślij Wiadomość
            </>
          )}
        </button>
      </div>
    </form>
  );
};


// ===================================================================
// === GŁÓWNY KOMPONENT STRONY /dla-szkol ===
// ===================================================================

const DlaSzkol = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  return (
    <div className="relative min-h-screen w-full">
      <NotebookBackground />
      
      {/* === NAWIGACJA (Stałe tło) === */}
      <nav className="fixed top-0 left-0 right-0 bg-blue-950 z-50 shadow-md text-[#F0F0F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex h-20 items-center justify-between">
            
            {/* 1. Logo i Nazwa */}
            <Link to="/" className="flex items-center gap-3">
              <img src={logo} alt="Matematly Logo" className="h-10 w-auto" />
              <span className="text-xl font-bold font-apotek uppercase tracking-wider">
                Matematly
              </span>
            </Link>

            {/* 2. Menu Desktopowe */}
            <div className="hidden md:flex items-center gap-6 text-sm font-medium">
              <Link to="/#dla-ucznia" className="opacity-80 hover:opacity-100 transition-opacity">Dla Ucznia</Link>
              <Link to="/dla-szkol" className="text-white font-semibold">Dla Szkół</Link>
              <Link to="/#cennik" className="opacity-80 hover:opacity-100 transition-opacity">Cennik</Link>
              <Link to="/#faq" className="opacity-80 hover:opacity-100 transition-opacity">FAQ</Link>
              <Link to="/register" className="ml-4 rounded-md bg-[#007D00] px-4 py-2 text-sm font-semibold text-white shadow-sm transition-transform hover:scale-105 hover:bg-green-600">
                Wypróbuj za Darmo
              </Link>
            </div>

            {/* 3. Przycisk Menu Mobilnego */}
            <div className="md:hidden">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2">
                {isMobileMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
              </button>
            </div>

          </div>
        </div>

        {/* 4. Rozwijane Menu Mobilne */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-blue-950 shadow-lg z-50 p-6 flex flex-col gap-6 text-lg font-semibold">
            <Link to="/#dla-ucznia" onClick={() => setIsMobileMenuOpen(false)}>Dla Ucznia</Link>
            <Link to="/dla-szkol" onClick={() => setIsMobileMenuOpen(false)}>Dla Szkół</Link>
            <Link to="/#cennik" onClick={() => setIsMobileMenuOpen(false)}>Cennik</Link>
            <Link to="/#faq" onClick={() => setIsMobileMenuOpen(false)}>FAQ</Link>
            
            <hr className="border-gray-700" />
            
            <Link to="/register" className="w-full text-center px-6 py-3 font-semibold text-white bg-[#007D00] rounded-lg shadow-lg">
              Wypróbuj 3 Dni za Darmo
            </Link>

            <hr className="border-gray-700" />

            <div className="text-sm opacity-70 flex gap-x-4 gap-y-1 justify-center flex-wrap">
              <Link to="/terms-of-service" onClick={() => setIsMobileMenuOpen(false)}>Regulamin</Link>
              <Link to="/privacy-policy" onClick={() => setIsMobileMenuOpen(false)}>Polityka Prywatności</Link>
              {/* === NOWE: WSPARCIE W MOBILE MENU === */}
              <Link to="/support" onClick={() => setIsMobileMenuOpen(false)}>Wsparcie</Link>
            </div>
          </div>
        )}
      </nav>
      {/* === KONIEC NAWIGACJI === */}


      {/* Przesuwamy całą treść, aby zrobić miejsce na nawigację */}
      <div className="relative z-10 pt-20"> 
        
        {/* ----- SEKCJA 1: HERO ----- */}
        <header className="bg-blue-950 pt-20 pb-24 px-6 text-center text-[#F0F0F0]">
          <h1 className="text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-balance font-apotek uppercase">
            INTELIGENTNE WSPARCIE W NAUCZANIU MATEMATYKI
          </h1>
          <p className="text-xl lg:text-2xl text-[#F0F0F0]/80 max-w-3xl mx-auto mb-10 text-balance">
            Odkryj platformę, która wspiera nauczanie przez nowoczesne metody, takie jak wykorzystanie systemu rankingowego ELO i inteligentne powtórki. 
            Matematly motywuje uczniów do regularnej, samodzielnej pracy, pomagając im budować i utrwalać wiedzę.
          </p>
        </header>

        {/* === SEKCJA 2: BENEFITY === */}
        <section id="co-zyskujesz" className="bg-transparent py-20 px-6 text-[#233855]">
          <h2 className="text-3xl font-bold text-center mb-12 font-apotek uppercase">
            Jak Matematly Wspiera Naukę matematyki?
          </h2>
          <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            
            <StudentBenefitItem 
              icon={<FiShield size={40} />}
              title="Indywidualne Ścieżki Nauki"
            >
              Nasz algorytm rankingowy ELO dba o to, by słabsi uczniowie nadrabiali braki na prostszych przykładach, a lepsi się nie nudzili, ale zawsze stawali przed nowymi problemami. Zapewniamy <b>możliwość rozwoju dla każdego</b>. 
            </StudentBenefitItem>
            
            <StudentBenefitItem 
              icon={<FiRepeat size={40} />}
              title="Budowanie Nawyków i Utrwalanie"
            >
              Aplikacja motywuje do codziennej nauki przez grywalizację i mechanizm serii. Dodatkowo, nasz system regularnie podsuwa materiał powtórkowy, <b>utrwalając nabyte umiejętności</b>.
            </StudentBenefitItem>
            
            <StudentBenefitItem 
              icon={<FiTrendingUp size={40} />}
              title="Błąd to Okazja do Nauki"
            >
              Gdy uczeń popełni błąd, dostaje nie tylko rozwiązanie krok po kroku i pomoc AI, ale też <b>kolejne zadania tego samego typu</b>, aby natychmiast przećwiczyć i zamienić pomyłkę w nową umiejętność.
            </StudentBenefitItem>

          </div>
        </section>

        {/* ----- SEKCJA 3: KONTAKT I ZAPROSZENIE ----- */}
        <section id="kontakt" className="bg-blue-950 py-20 px-6 text-[#F0F0F0]">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            
            {/* Lewa kolumna: Tekst (Pitch) */}
            <div className="md:pr-8">
              <h2 className="text-3xl font-bold mb-4 font-apotek uppercase">
                Rozwijamy narzędzia dla szkół
              </h2>
              <p className="text-lg text-[#F0F0F0]/80 mb-6 text-balance">
                Obecnie Matematly to platforma skupiona na uczniach. Otrzymujemy jednak coraz więcej zapytań od nauczycieli.
              </p>
              <p className="text-lg text-[#F0F0F0]/80 mb-6 text-balance">
                Rozpoczynamy prace koncepcyjne nad panelem dla profesjonalistów i chcemy budować go w oparciu o Państwa realne potrzeby.
              </p>
              <p className="text-lg text-white font-semibold text-balance">
                Jeśli masz pomysły, chcesz podzielić się swoimi wyzwaniami w nauczaniu lub jesteś zainteresowany przyszłym pilotażem – wypełnij formularz.
              </p>
            </div>

            {/* Prawa kolumna: Formularz */}
            <div className="bg-[#0a101f]/50 p-6 sm:p-8 rounded-lg border border-gray-700">
              <ContactFormB2B />
            </div>

          </div>
        </section>
        
        {/* ----- SEKCJA 4: STOPKA ----- */}
        <footer id="footer" className="bg-blue-950 text-[#F0F0F0]/70">
          <div className="max-w-7xl mx-auto py-16 px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-12">
            
            {/* Kolumna 1: Logo i Copyright */}
            <div className="col-span-1 md:col-span-1">
              <div className="flex items-center gap-3 mb-4">
                <img src={logo} alt="Matematly Logo" className="h-10 w-auto" />
                <span className="text-xl font-bold font-apotek uppercase tracking-wider text-white">
                  Matematly
                </span>
              </div>
              <p className="text-sm">
                © {new Date().getFullYear()} Matematly. Wszelkie prawa zastrzeżone.
              </p>
            </div>
            
            {/* Kolumna 2: Produkt */}
            <div>
              <h4 className="font-semibold text-white uppercase tracking-wider mb-4">Produkt</h4>
              <nav className="flex flex-col gap-3 text-sm">
                <Link to="/#dla-ucznia" className="hover:text-white">Dla Ucznia</Link>
                <Link to="/dla-szkol" className="hover:text-white">Dla Szkół</Link>
                <Link to="/#cennik" className="hover:text-white">Cennik</Link>
              </nav>
            </div>

            {/* Kolumna 3: Zasoby */}
            <div>
              <h4 className="font-semibold text-white uppercase tracking-wider mb-4">Zasoby</h4>
              <nav className="flex flex-col gap-3 text-sm">
                <Link to="/terms-of-service" className="hover:text-white">Regulamin</Link>
                <Link to="/privacy-policy" className="hover:text-white">Polityka Prywatności</Link>
                {/* === NOWE: WSPARCIE === */}
                <Link to="/support" className="hover:text-white">Wsparcie</Link>
                <Link to="/#faq" className="hover:text-white">FAQ</Link>
              </nav>
            </div>

            {/* Kolumna 4: Kontakt */}
            <div>
              <h4 className="font-semibold text-white uppercase tracking-wider mb-4">Kontakt</h4>
              <div className="flex flex-col gap-3 text-sm">
                <a href="mailto:kontakt@matematly.pl" className="hover:text-white">kontakt@matematly.pl</a>
                <div className="mt-2">
                  <p>Matematly Sp. z o. o. </p>
                  <p>Aleja Powstania Warszawskiego 15</p>
                  <p>31-539 Kraków</p>
                  <p className="opacity-90">NIP: 6751821918</p>
                </div>
              </div>
            </div>

          </div>
        </footer>

      </div>
    </div> 
  );
};

export default DlaSzkol;